document.addEventListener("DOMContentLoaded", function() {
  let charityBlock = document.getElementById("charity_block");
  let labelSpan = document.getElementById("charity_selected_label");

  if (charityBlock) {
    let radioButtons = charityBlock.querySelectorAll("input[type='radio']");

    if (radioButtons.length > 0) {
      // Seleziona il primo input radio
      radioButtons[0].checked = true;
      // Mostra il valore selezionato nello span
      labelSpan.textContent = radioButtons[0].value;

      // Aggiungi un listener per aggiornare lo span quando cambia la selezione
      radioButtons.forEach(radio => {
        radio.addEventListener("change", function() {
          labelSpan.textContent = this.value;
        });
      });
    }
  }
});


document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector('form[action="/cart/add"]') && !document.querySelector('form[action="/it/cart/add"]') ){
    return; // ⛔ Non è una pagina prodotto, esci
  }
  // Rileva la lingua della pagina (basato su tag html: <html lang="en"> o <html lang="it">)
  let language = document.documentElement.lang;

  // Selettori e testi dinamici
  let variantSelector = 'input[type="radio"][data-variant-id][data-stock]';
  let inStockText = language === "it" 
    ? "<span class='bold' style='text-align:left !important'>Solo {{stock}} in stock.</span>"
    : "<span class='bold'>Only {{stock}} still available.</span>";

  let variantRadios = document.querySelectorAll(variantSelector);
  let message = document.getElementById("availability-message");
  let textBlock = document.getElementById("not_in_stock_text");
  let inStockQnty = document.getElementById("in_stock_quantity");

  function updateMessage() {
    let selectedVariant = document.querySelector(variantSelector + ":checked");
    if (!selectedVariant) return;

    let totalStock = parseInt(selectedVariant.dataset.stock, 10);
    console.log(selectedVariant.dataset);
    let variantId = selectedVariant.dataset.variantId; // Assicurati che il value sia l'ID variante

    // Ottieni il contenuto del carrello
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        let cartItem = cart.items.find(item => item.variant_id == variantId);
        let qtyInCart = cartItem ? cartItem.quantity : 0;

        let remainingStock = totalStock - qtyInCart;

        if (remainingStock > 0) {
          inStockQnty.innerHTML = inStockText.replace("{{stock}}", remainingStock);
          inStockQnty.style.display = "block";
          textBlock.style.display = "none";
        } else {
          inStockQnty.style.display = "none";
          //textBlock.style.display = "block";
        }
      })
      .catch(error => {
        console.error("Errore nel recuperare il carrello:", error);
      });
  }

  // Inizializza il messaggio al caricamento della pagina
  updateMessage();

  // Aggiorna il messaggio quando si seleziona una variante
  variantRadios.forEach(radio => {
    radio.addEventListener("change", updateMessage);
  });

  (function () {
    const originalFetch = window.fetch;
  
    window.fetch = function (...args) {
      const [url, config] = args;
  
      const isCartMutation = (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      );
  
      if (isCartMutation && config && config.method === 'POST') {
        return originalFetch(...args).then(response => {
          // Delay per essere sicuri che il carrello sia aggiornato
          setTimeout(() => {
            updateMessage();
          }, 500);
          return response;
        });
      }
  
      return originalFetch(...args);
    };
  })();
});



